import { forwardRef } from 'react'
import { cn } from '~/lib/utils'

export interface FormCardProps extends React.HTMLAttributes<HTMLDivElement> {
  noBottomMargin?: boolean
}

export const FormCard = forwardRef<HTMLDivElement, FormCardProps>(
  ({ noBottomMargin = false, className, ...props }, ref) => {
    const cardClasses = cn(
      'bg-white',
      'rounded-lg',
      'mt-4',
      !noBottomMargin && 'mb-8',
      'lg:p-6',
      className
    )

    return <div ref={ref} className={cardClasses} {...props} />
  }
)

FormCard.displayName = 'FormCard'
